import React, { useEffect, useState } from 'react'

const MenuItem = ({ data }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    return (
        <li className="z-50 relative text-gray-700 hover:text-blue-600 font-medium"
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
        >
            <span className="ml-0 [&>svg]:w-5 w-2 inline">
                <span className='inline'>{data.title}</span>
                <svg className='inline'
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                >
                    <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                        clipRule="evenodd"
                    />
                </svg>
            </span>

            {isDropdownOpen && (
                <ul
                    className="absolute left-0 mt-0 w-36 bg-white text-black shadow-lg"
                    onMouseEnter={() => setIsDropdownOpen(true)}
                >
                    {data.items && data.items.map((item, idx) => {
                        return (
                            item.focus ?
                                <a className="px-4 py-2 rounded-full border border-1  hover:bg-gray-200 block" href={item.path} target={item.target ? item.target : '_self'}>
                                    {item.title}
                                </a>
                                : <a className="px-4 py-2 hover:bg-gray-200 block" href={item.path} target={item.target ? item.target : '_self'}>
                                    {item.title}
                                </a>
                        )
                    })}
                </ul>
            )}
        </li>
    );
};

const Navbar = ({ data }) => {
    const [state, setState] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [openMobileIndex, setOpenMobileIndex] = useState(null);

    const checkMobile = () => {
        setIsMobile(window.matchMedia("(max-width: 767px)").matches);
    };

    useEffect(() => {
        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    useEffect(() => {
        document.onclick = (e) => {
            const target = e.target;
            if (!target.closest(".menu-btn") && !target.closest(".mobile-drawer")) setState(false);
        };
    }, [])

    const Brand = () => (
        <div className="flex flex-1 items-center justify-between py-5">
            <div className='flex flex-row'>
                <a href="javascript:void(0)" >
                    <img
                        src={data.logo}
                        alt="memo Logo"
                        className="h-10 md:h-12 max-w-[160px] h-full object-contain"
                    />
                </a>
            </div>

            <div className="md:hidden">
                <button className="menu-btn text-gray-400"
                    onClick={() => setState(!state)}
                >
                    {
                        state ? (
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                            </svg>
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                            </svg>
                        )
                    }
                </button>
            </div>
        </div>
    )

    return (
        <header className="z-30 relative">
            {/* 只在大屏显示的背景遮罩 */}
            <div
                className="hidden md:block fixed top-0 left-0 right-0 h-[96px] z-[-1]"
                style={{
                    background:
                        "linear-gradient(90deg, rgb(0, 222, 161) 0%, rgb(0, 222, 161) 10%, #3fb2dd 30%, hsl(220, 97.3%, 55.9%) 100%)",
                }}
            ></div>
            {/* 导航栏 */}
            <nav className="fixed left-0 right-0 flex justify-center top-0 md:top-[24px] w-full max-w-full">
                <div
                    className="bg-white md:rounded-lg shadow-xl border border-gray-200 flex items-center w-full max-w-full px-2 sm:px-4 md:px-6 lg:px-8 md:w-auto md:mx-auto md:max-w-[1440px] lg:w-[70%]"
                    style={{ height: '60px' }}
                >

                    <Brand />
                    <div className={`flex-2 items-center ml-auto md:flex hidden`}>
                        <ul className="flex-2 justify-end items-center space-y-5 md:flex md:space-x-5 md:space-y-0">
                            {
                                data.navigation && data.navigation.map((item, idx) => {
                                    return (
                                        <>
                                            {(!item.items) && (
                                                item.focus ?
                                                    <li key={idx} className="px-3 py-2 bg-blue-400 rounded-full border border-1 text-gray-100 hover:text-gray-50">
                                                        <a href={item.path} target={item.target ? item.target : '_self'} className="block flex flex-nowrap">
                                                            <img src="/point.png" alt="" style={{ width: 25 }} /><span className='px-1'>{item.title}</span>
                                                        </a>
                                                    </li> :
                                                    <li key={idx} className="text-gray-700 hover:text-blue-600 font-medium">
                                                        <a href={item.path} target={item.target ? item.target : '_self'} className="block px-3 py-2">
                                                            {item.title}
                                                        </a>
                                                    </li>
                                            )}
                                            {item.items && (!isMobile) && <MenuItem data={item} />}
                                        </>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </div>

                {state && isMobile && (
                    <div className="mobile-drawer fixed top-[60px] left-12 right-2 bg-white z-40 shadow-md px-4 py-4 md:hidden rounded-md">
                        <ul className="space-y-2">
                            {data.navigation.map((item, idx) => (
                                <React.Fragment key={idx}>
                                    {!item.items && (
                                        <li className="text-gray-800 hover:text-blue-600 font-medium">
                                            <a
                                                href={item.path}
                                                target={item.target || "_self"}
                                                className="block px-3 py-1"
                                            >
                                                {item.title}
                                            </a>
                                        </li>
                                    )}

                                    {item.items && (
                                        <li className="text-gray-800 font-semibold">
                                            <button
                                                type="button"
                                                className="w-full flex items-center justify-between px-3 py-1 text-left hover:text-blue-600"
                                                onClick={() => setOpenMobileIndex(openMobileIndex === idx ? null : idx)}
                                            >
                                                <span>{item.title}</span>
                                                <svg
                                                    className={`w-4 h-4 transition-transform ${openMobileIndex === idx ? 'rotate-180' : ''}`}
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 20 20"
                                                    fill="currentColor"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                                                        clipRule="evenodd"
                                                    />
                                                </svg>
                                            </button>
                                            {openMobileIndex === idx && (
                                                <ul className="mt-1 space-y-1">
                                                    {item.items.map((subitem, subidx) => (
                                                        <li key={subidx} className="text-gray-800 hover:text-blue-600 font-medium pl-5">
                                                            <a
                                                                href={subitem.path}
                                                                target={subitem.target || "_self"}
                                                                className="block px-3 py-1 text-sm"
                                                            >
                                                                {subitem.title}
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    )}
                                </React.Fragment>
                            ))}
                        </ul>
                    </div>
                )}

            </nav>
        </header>
    )
}

export default Navbar